<!--
 * @Description: ''
 * @Author: yangruonan(yangruonan@hztianque.com)
 * @Date: 2021-04-28 11:06:06
 * @LastEditTime: 2021-05-08 10:13:15
-->
<template>
  <div class="hotel-mask">
    <Modal
      v-model="showModel"
      @on-cancel="cancelModel"
      :mask-closable="false"
      :title="modalTitle">
      <Form
        ref="formValidate"
        :model="formValidate"
        :label-width="80"
        :rules="ruleValidate">
        <FormItem label="酒店名称" prop="hotelName">
          <Input v-model="formValidate.hotelName" maxlength="20" placeholder="最多可输入20个字符"></Input>
        </FormItem>
        <FormItem label="类型" prop="hotelType">
          <Input v-model="formValidate.hotelType" maxlength="20" placeholder="最多可输入20个字符"></Input>
        </FormItem>
        <FormItem label="库存" prop="stock" v-if="!formValidates.id">
          <Input v-model="formValidate.stock" type="number" placeholder="请输入正整数"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelModel">取消</Button>
        <Button type="primary" :loading="loading" @click="asyncSaveOK('formValidate')">确定</Button>
      </div>
</Modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    modalTitle: {
      type: String,
      default: '标题',
    },
    formValidates: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showModel: this.show,
      formValidate: {},
      ruleValidate: {
        hotelName: [
          { required: true, message: '请输入酒店名称', trigger: 'blur,change' },
          {
            // eslint-disable-next-line no-unused-vars
            validator: (rule, value, callback) => {
              const str = value.trim()
              const len = 20
              if (str) {
                if (str.length <= len) {
                  callback()
                } else {
                  callback(`酒店名称名称最多输入${len}字`)
                }
              }
            },
            trigger: 'blur',
          },
        ],
        hotelType: [
          { required: true, message: '请输入类型' },
        ],
        stock: [
          { required: true, message: '请输入正整数', trigger: 'blur,change' },
          {
            // eslint-disable-next-line no-unused-vars
            validator: (rule, value, callback) => {
              const reg = /^\+?[1-9][0-9]*$/ //正整数
              if (reg.test(value)) {
                if (Number(value) > 99999) {
                  callback('库存不能大于99999')
                } else {
                  callback()
                }
              } else {
                callback('请输入正整数')
              }
            },
            trigger: 'blur,change',
          },
        ],
      },
      loading: false,
    }
  },
  watch: {
    show(val) {
      this.showModel = val
      if (val && this.modalTitle === '新增酒店') {
        this.$refs['formValidate'].resetFields()
      }
    },
    formValidates: {
      deep: true,
      handler(val) {
        this.formValidate = val
      },
    },
  },
  created() {},
  methods: {
    // 关闭
    cancelModel() {
      this.showModel = false
      this.$refs['formValidate'].resetFields()
      this.$emit('showModel', { modal: false })
    },
    // 确定
    async asyncSaveOK(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          this.addHotel()
        }
      })
    },
    async addHotel() {
      if (this.formValidates.id) {
        // 修改
        await this.update(this.formValidate).then(res => {//eslint-disable-line
          if (res.code === '0' && res.flag === '0') {
            this.$Message.success('修改成功!')
            this.closeModal()
            this.$emit('showModel', { modal: false, type: 'update' })
            this.loading = false
          }
        })
          .catch(err => {
            this.$Message.error(err.message)
          })
      } else {
        // 新增酒店
        await this.save(this.formValidate).then(res => {//eslint-disable-line
          if (res.code === '0' && res.flag === '0') {
            this.$Message.success('新增成功!')
            this.closeModal()
            this.$emit('showModel', { modal: false, type: 'add' })
            this.loading = false
          }
        }).catch(err => {
          this.$Message.error(err.message)
        })
      }
      this.$refs['formValidate'].resetFields()
    },
    closeModal() {
      this.$refs['formValidate'].resetFields()
      this.showModel = false
      this.$emit('showModel', false)
    },
    ...mapActions({
      save: 'jurisprudenceDaily/hotelManagement/save',
      update: 'jurisprudenceDaily/hotelManagement/update',
    }),
  },
}
</script>
<style lang="scss" scoped>

</style>
